import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (!token) {
      navigate("/login");
      return;
    }

    axios
      .post(
        "https://admin-node-api.amanueltesfaye55.workers.dev/admin/auth/verify",
        { token },
      )
      .then((res) => {
        sessionStorage.setItem("jwt", res.data.token);
        navigate("/dashboard");
      })
      .catch(() => {
        navigate("/login");
      });
  }, [navigate]);
  return (
    <div
      style={{
        height: "100dvh",
        width: "100dvw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1>Verifying token...</h1>
    </div>
  );
}
